import React, { FC, ReactNode } from 'react'
import { Stack } from '@mui/material'

// 無見出し inline filter row. table 直上に配置. design/18 §2.3 R4.
// flex-wrap で row 折り返し. align-items="flex-end" で label 行を揃える.
interface FilterRowProps {
  children: ReactNode
}

export const FilterRow: FC<FilterRowProps> = ({ children }) => (
  <Stack
    direction="row"
    flexWrap="wrap"
    gap={2}
    alignItems="flex-end"
    sx={{ py: 1 }}
  >
    {children}
  </Stack>
)
